import { consts } from '../consts/consts'

export let filtered = {
  accounts: {
    nonSystem: accounts => accounts.filter(acct => acct.id !== consts.accounts.system.id)
  }
}